// src/components/Footer.tsx
import React from "react";
import "../../assets/styles/Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {new Date().getFullYear()} LavernAI cbc. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
